const MobileMixin = {
  //   data: function() {
  //   },
  methods: {
    candidateMatchTypeahead(candidate) {
      // console.log("--------x-x---x-x-x-x-x-x--x-x-x-x-x-x-x-x-x-x-x-x-x--x-x");
      // console.log(candidate);
      // console.log(this.candidates.length);
      if (this.showAll) return true;
      if (this.candidates.length <= 20) return true;
      if (this.typeahead.length < 2) return false;
      let res = null;
      if (candidate.CandidateIdentifier) {
        res = candidate.CandidateIdentifier.CandidateName.toLowerCase().includes(
          this.typeahead.toString().toLowerCase()
        );
      } else {
        res = candidate.AffiliationIdentifier.RegisteredName.toLowerCase().includes(
          this.typeahead.toString().toLowerCase()
        );
      }

      return res;
    },
    async getContest(contestId) {
      let contest = await this.$store.state.ceoCbbService.getContest(
        this.$store.state.voterIdentification.EventIdentifier.Id,
        contestId,
        this.$store.state.voterIdentification.Voter.VoterIdentifier.VoterId[0]
      );
      if (contest.error) {
        //console.error(contest.error);
        alert(contest.error + "\n\n" + this.$store.state.alertMessage);
        return;
      }

      if (this.listOrCandidates === "CANDIDATES") {
        return contest.ChoicesContest[0].BallotChoices.Candidate;
      }
      if (this.listOrCandidates === "AFFILIATIONS") {
        return contest.ChoicesContest[0].BallotChoices.Affiliation;
      }
      if (this.preference) {
        return contest.ChoicesContest[0].BallotChoices.Candidate;
      }
    },
    //funzioni paginazione
    mostraTutti() {
      this.page = 1;
      if (this.showAll) {
        this.typeahead = "";
      }
    },
    setPages(res) {
      this.page = 1;
      let numberOfPages = Math.ceil(res.length / this.perPage);
      this.pages = [];
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(posts) {
      this.pageChanged = false;
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return posts.slice(from, to);
    }
  },
  computed: {
    displayedPosts() {
      let results;
      results = this.candidates;

      if (this.typeahead) {
        if (this.listOrCandidates == "AFFILIATIONS") {
          results = this.candidates.filter(candidate => {
            return candidate.AffiliationIdentifier.RegisteredName.toLowerCase().includes(
              this.typeahead.toString().toLowerCase()
            );
          });
        } else {
          results = this.candidates.filter(candidate => {
            return candidate.CandidateIdentifier.CandidateName.toLowerCase().includes(
              this.typeahead.toString().toLowerCase()
            );
          });
        }
      } else {
        if (this.candidates.length > 20 && !this.showAll) results = [];
      }

      if (this.pageChanged == false) this.setPages(results);
      return this.paginate(results);
    }
  }
};

export default MobileMixin;
